module.exports = __webpack_public_path__ + "f3d032dc4b633ab201388019d780c2d6.svg";